<div class="app-container">
  <div class="primary-co">
    <infinite-scroll-provider>
      <header class="app-header">
        <!-- @defer { -->
          <app-navigation [isClubMember]="isClubMember | async"></app-navigation>
        <!-- } -->
      </header>
      <main class="app-main" id="mainPage">
        <router-outlet></router-outlet>
      </main>
      <div class="desktop desktop-footer">
        <!-- @defer { -->
          <app-footer></app-footer>
        <!-- } -->
      </div>
    </infinite-scroll-provider>
  </div>
  <div class="app-footer">
    <app-mobile-navigation
      [isClubMember]="isClubMember | async"
    ></app-mobile-navigation> 
  </div>
</div>

<ng-template #storeGroupsDialog>
  @if (storeGroups) {
    <div class="store-groups-container">
      <img class="logo" [src]="storeDetail?.logo" [alt]="storeDetail?.name" />
      <br />
      <p class="title">
        <!-- @defer(){
          {{ 'wrapper.regionSelect' | translate }}:
        }
        @placeholder { -->
          Please Choose Your Region:
        <!-- } -->
      </p>
      <br />
      <div class="countries">
        @for (item of storeGroups; track item) {
          <div>
            <div class="country" (click)="setStoreGroup(item?.client_id)">
              <div class="image-container">
                <img [src]="item?.country_detail?.image" />
              </div>
              <p>{{ item?.country_detail?.name }}</p>
            </div>
          </div>
        }
      </div>
      <br />
      <br />
      <button
        mat-flat-button
        mat-dialog-close
        color="primary"
        (click)="stayOnCurrentPage(storeDetail?.client_id)"
        >
        <!-- @defer(){
          {{ 'wrapper.currentPage' | translate }}
        }
        @placeholder { -->
          Keep current page
        <!-- } -->
      </button>
    </div>
  }
</ng-template> 
